import React from 'react';

import classNames from 'classnames';

type TransparentCardProps = {
  children: React.ReactNode;
  className?: string;
};

const TransparentCard = ({ children, className }: TransparentCardProps) => (
  <div
    className={classNames(
      'bg-white/5 rounded-lg backdrop-blur-sm shadow-md border-white/10 border-solid border-[1px] p-6 sm:p-8',
      className,
    )}
  >
    {children}
  </div>
);

export default TransparentCard;
